module.exports = __webpack_public_path__ + "img/kg.c8d9568e.svg";